// extracted by mini-css-extract-plugin
export default {"container":"Study_container__e32fI"};